// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// element-ui配置
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
import VuePannellum from 'vue-pannellum';
// Vue.use(VuePannellum);
Vue.component('VPannellum', VuePannellum)


// 饿了么对手机端UI配置
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(Mint)

import App from './App'
import router from './router'
import $ from 'jquery'

// import dialog from '@/components/commons/dialog'
// Vue.use(dialog)


import bus from '@/utils/bus.js'
Vue.prototype.$bus = bus;

// 配置Vant插件
import 'vant/lib/index.css';
import { Popup  } from 'vant';
Vue.use(Popup);

// 全局css样式
// import '@/components/styles/common.css'

// router的拦截配置
import './permission'
// ajax请求的配置
import axios from '@/utils/request'
import vueAxios from 'vue-axios'
Vue.use(vueAxios, axios)
Vue.prototype.$axios = axios
// 设置vuex信息
import store from './store/index'
// // swiper
import Swiper from 'swiper'
import '../node_modules/swiper/dist/css/swiper.css'

//懒加载图片插件
import 'jquery-lazyload'


import utils from '@/utils/utils.js' // 设置工具类
// import common from '@/utils/common.js' // 公共内容
import constant from '@/api/constant.js' // 全局常量
Vue.prototype.$utils = utils
// Vue.prototype.$common = common
Vue.prototype.$constant = constant


// 移动端图片缩放切换
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(vuePhotoPreview, preview)
import { Swipe, SwipeItem } from 'Vant'
Vue.use(Swipe);
Vue.use(SwipeItem);
import { Tab, Tabs } from 'vant';

Vue.use(Tab);
Vue.use(Tabs);
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(Vue2TouchEvents)



	
import fabric from 'fabric'  // 在项目中引入并使用Fabric.js库
Vue.use(fabric);

//移动端左右滑动
import VueTouch from "vue-touch";
Vue.use(VueTouch, {name: "v-touch"});


// md5
// import md5 from 'js-md5'
// Vue.protoType.$md5 = md5

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js